import React from 'react';
import axios from 'axios';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Home from './controllers/home';
import Login from './controllers/login';
import Register from './controllers/register';
// import Nvdi from './controllers/nvdi';
import Statistic from './controllers/statistic';
import Storage from './controllers/storage';
import useToken from './services/token';
import { SSEProvider } from 'react-hooks-sse';
// import Flight from './controllers/flight';
// import Fertilizer from './controllers/fertilizer';
// import Weed from './controllers/weed';
import ForgotPassword from './controllers/ForgotPassword';
import ResetPassword from './controllers/ResetPassword';
import Profile from './controllers/profile';
import Cultures from './components/culture/Cultures';
import DataEntry from './controllers/dataEntry';
import KnowledgeBase from './controllers/knowledgeBase';
import GlobalSpectralBatchProgress from './components/field/GlobalSpectralBatchProgress';
import AdminPage from './controllers/admin';
import TeamPage from './controllers/team';
import AcceptInvite from './controllers/AcceptInvite';
import { OnboardingProvider } from './components/onboarding/OnboardingProvider';
const App = () => {
    var _a, _b, _c;
    const { token, verify, removeToken, parseJwt } = useToken();
    const onboardingUser = React.useMemo(() => token ? parseJwt(token) : null, [token]);
    const navigate = useNavigate();
    const location = useLocation();
    React.useEffect(() => {
        const interceptorId = axios.interceptors.response.use((response) => response, (error) => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                removeToken();
                if (location.pathname !== '/login') {
                    navigate('/login');
                }
                // Ошибка уже полностью обработана (токен очищен, идёт редирект
                // на логин) — намеренно НЕ пере-выбрасываем её дальше. Компоненты
                // вроде ListField делают axios.get(...).then(...) без .catch(),
                // и повторный reject улетал бы необработанным (Uncaught in
                // promise), что webpack-dev-server показывает как полноэкранный
                // оверлей, хотя приложение уже корректно восстановилось.
                // "Зависший" промис никогда не resolve/reject — безопасно,
                // потому что страница и так уводит пользователя на /login.
                return new Promise(() => { });
            }
            return Promise.reject(error);
        });
        return () => axios.interceptors.response.eject(interceptorId);
    }, []);
    React.useEffect(() => {
        // Разрешаем доступ к странице регистрации без токена
        if (location.pathname === '/register') {
            return;
        }
        if (location.pathname === '/forgot-password') {
            return;
        }
        if (location.pathname === '/reset-password') {
            return;
        }
        if (location.pathname === '/accept-invite') {
            return;
        }
        if (!token && token !== "" && token !== undefined) {
            removeToken();
            if (location.pathname !== '/login') {
                navigate('/login');
            }
        }
        else {
            if (verify() === false) {
                removeToken();
                navigate('/login');
            }
        }
    }, [location.pathname]);
    // Если пользователь на странице регистрации
    if (location.pathname === '/register') {
        return React.createElement(Register, null);
    }
    if (location.pathname === '/forgot-password') {
        return React.createElement(ForgotPassword, null);
    }
    if (location.pathname === '/reset-password') {
        return React.createElement(ResetPassword, null);
    }
    if (location.pathname === '/accept-invite') {
        return React.createElement(AcceptInvite, null);
    }
    if (!token && token !== "" && token !== undefined)
        return React.createElement(Login, null);
    const authenticatedContent = (React.createElement(OnboardingProvider, { key: (_a = onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.id) !== null && _a !== void 0 ? _a : 'anonymous', userId: (_b = onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.id) !== null && _b !== void 0 ? _b : null, role: (_c = onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) !== null && _c !== void 0 ? _c : null },
        (onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) !== 'user' && React.createElement(GlobalSpectralBatchProgress, null),
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/", element: React.createElement(Home, { token: token }) }),
            React.createElement(Route, { path: "/storage", element: (onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) === 'user' ? React.createElement(Navigate, { to: "/" }) : React.createElement(Storage, { token: token }) }),
            React.createElement(Route, { path: "/statistic", element: (onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) === 'user' ? React.createElement(Navigate, { to: "/" }) : React.createElement(Statistic, { token: token }) }),
            React.createElement(Route, { path: "/login", element: React.createElement(Navigate, { to: "/" }) }),
            React.createElement(Route, { path: "/profile", element: React.createElement(Profile, { token: token }) }),
            React.createElement(Route, { path: "/cultures", element: (onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) === 'user' ? React.createElement(Navigate, { to: "/" }) : React.createElement(Cultures, { token: token }) }),
            React.createElement(Route, { path: "/data-entry", element: (onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) === 'user' ? React.createElement(Navigate, { to: "/" }) : React.createElement(DataEntry, { token: token }) }),
            React.createElement(Route, { path: "/knowledge-base", element: React.createElement(KnowledgeBase, { token: token }) }),
            React.createElement(Route, { path: "/admin", element: React.createElement(AdminPage, { token: token }) }),
            React.createElement(Route, { path: "/team", element: React.createElement(TeamPage, { token: token }) }))));
    // A user awaiting a role has no field data to subscribe to.
    return (onboardingUser === null || onboardingUser === void 0 ? void 0 : onboardingUser.role) === 'user'
        ? authenticatedContent
        : React.createElement(SSEProvider, { endpoint: `/sse/${token}` }, authenticatedContent);
};
export default App;
